import { forwardRef, useRef, useState } from "react";
import { Description, FormContainer, ImgEtapa, ImgLogo, Label, TitleAnamnese } from "../commons";
import { Form, Row } from "react-bootstrap";
import LogoFull from "../../../Images/logo_full.png"
import LogoEtapa from "../../../Images/cadastrando_anamnese.png"
import { Input } from "../../../components/Input";
import { VbCheckBox } from "../../../components/VbCheckBox";
import { VbFormLabel } from "../../../components/VbControls";
import { VbButton } from "../../../components/VbButton";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { toast } from "react-toastify";
import { toastError } from "../../../commons/utils";

export const AnamensePub = forwardRef((props: any, ref) => {
    const auth = useAuth();

    const [fisicamente, setFisicamente] = useState({ sedentaria: 0, musculacao: 0, pilates: 0, fisioterapia: 0, outros: 0 });
    const [sedentaria, setSedentaria] = useState({ seismeses: 0, umano: 0, nunca: 0 });
    const [frase, setFrase] = useState({ tentando: 0, comecei: 0, jatreino: 0 });

    const [lesao, setLesao] = useState({ sim: 0, nao: 0 });
    const lesao_desc_ref = useRef<any>(null);
    const dificil_exercitar_ref = useRef<any>(null);
    const [dificuldadesecuidar, setDificuldadeSeCuidar] = useState({ tempo: 0, motivacao: 0, solitario: 0, frustrei: 0, naoseicomecar: 0, outra: 0 });
    const dividir_ref = useRef<any>(null);

    const [perfeccionista, setPerfeccionista] = useState({ sim: 0, nao: 0 });
    const [seujeito, setSeujeito] = useState({ sim: 0, nao: 0 });
    const [perfil, setPerfil] = useState({ introvertida: 0, extrovertida: 0 });
    const [execucao, setExecucao] = useState({ independente: 0, dependente: 0 });
    const [aprendizado, setAprendizado] = useState({ tato: 0, visual: 0, auditiva: 0 });

    const gestanteSemanas_ref = useRef<any>(null);
    const [sintomas, setSintomas] = useState({ tontura: 0, desmaios: 0, escurecimento: 0, dorPeito: 0, taquicardia: 0, faltaAr: 0, nenhum: 0 });
    const cirurgia_ref = useRef<any>(null);
    const [hipertensao, setHipertensao] = useState({ sim: 0, nao: 0 });
    const [cardio, setCardio] = useState({ sim: 0, nao: 0 });
    const [medico, setMedico] = useState({ sim: 0, nao: 0 });

    const [formatoTreino, setFormatoTreino] = useState({ presencial: 0, online: 0, ambos: 0, naoSei: 0 });
    const instagram_ref = useRef<any>(null);
    const compartilha_ref = useRef<any>(null);

    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState<any>(false);
    const [termo, setTermo] = useState<any>();

    async function upsert() {
        const params: any = new URLSearchParams(window.location.search);

        async function execute() {
            let body = {
                prospect: {
                    prosptoken: params.get("u_prospect")
                },
                anamn2rotinafisica:
                    (fisicamente.sedentaria ? 1 : 0) +
                    (fisicamente.musculacao ? 2 : 0) +
                    (fisicamente.pilates ? 4 : 0) +
                    (fisicamente.fisioterapia ? 8 : 0) +
                    (fisicamente.outros ? 16 : 0),
                anamn2temposedentaria: (sedentaria.seismeses ? 1 : sedentaria.umano ? 2 : 3),
                anamn2frasehoje: (frase.tentando ? 1 : frase.comecei ? 2 : 3),

                anamn2temlesao: lesao.sim === 1,
                anamn2lesaodesc: lesao_desc_ref?.current?.getValue() ?? '',
                anamn2dificilexercitar: dificil_exercitar_ref?.current?.getValue() ?? '',
                anamn2dificuldadeprincipal:
                    (dificuldadesecuidar.tempo ? 1 : 0) +
                    (dificuldadesecuidar.motivacao ? 2 : 0) +
                    (dificuldadesecuidar.solitario ? 4 : 0) +
                    (dificuldadesecuidar.frustrei ? 8 : 0) +
                    (dificuldadesecuidar.naoseicomecar ? 16 : 0) +
                    (dificuldadesecuidar.outra ? 32 : 0),
                anamn2dividirsonho: dividir_ref?.current?.getValue() ?? '',

                anamn2perfeccionista: perfeccionista.sim === 1,
                anamn2seujeito: seujeito.sim === 1,
                anamn2perfiltipo: perfil.introvertida ? 1 : 2,
                anamn2execucaotipo: execucao.independente === 1 ? 1 : 2,
                anamn2aprendizadotipo: (aprendizado.tato ? 1 : aprendizado.visual ? 2 : 3),

                anamn2gestante: gestanteSemanas_ref.current.getValue() || '',
                anamn2sintomaprincipal:
                    (sintomas.tontura ? 1 : 0) +
                    (sintomas.desmaios ? 2 : 0) +
                    (sintomas.escurecimento ? 4 : 0) +
                    (sintomas.dorPeito ? 8 : 0) +
                    (sintomas.taquicardia ? 16 : 0) +
                    (sintomas.faltaAr ? 32 : 0) +
                    (sintomas.nenhum ? 64 : 0),
                anamn2cirurgiadesc: cirurgia_ref.current.getValue() || '',
                anamn2hipertensao: hipertensao.sim === 1,
                anamn2doencacardiovascular: cardio.sim === 1,
                anamn2medicoregular: medico.sim === 1,

                anamn2formatotreino: (formatoTreino.presencial ? 1 : formatoTreino.online ? 2 : formatoTreino.ambos ? 3 : 4),
                anamn2instagram: instagram_ref?.current?.getValue() || '',
                anamn2compartilha: compartilha_ref?.current?.getValue() || '',

                // anamn2datacadastro deixamos automático no banco
            };

            setLoading(true);

            await auth.post('anamnese2', body).then(() => {
                toast.success('Anamnese enviada com sucesso.');
                window.location.replace('/success-form');
            }).catch((error: any) => {
                toastError(error)
            }).finally(() => {
                setLoading(false);
            })
        }

        execute();
    }

    const handleSubmit = (e: any) => {
        const form = e.currentTarget;

        if (form.checkValidity() === true) {
            if (termo === 0)
                toast.error('Termo de responsabilidade não foi aceito.')
            else
                upsert()
        } else
            setValidated(true);

        e.preventDefault();
        e.stopPropagation();
    };

    const handleCheckboxChange = (key: string, setState: React.Dispatch<React.SetStateAction<any>>, isRadio: boolean = false) => (e: any) => {
        setState((prev: any) => {
            if (isRadio) {
                const updatedState = Object.keys(prev).reduce((acc, currKey) => {
                    acc[currKey] = currKey === key && e.target.checked ? 1 : 0;
                    return acc;
                }, {} as any);
                return updatedState;
            } else {
                return { ...prev, [key]: e.target.checked ? 1 : 0 };
            }
        });
    };


    return (
        <FormContainer className="d-flex flex-column">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mb-3 justify-content-center">
                    <ImgLogo src={LogoFull} />
                    <Row className="justify-content-center">
                        <ImgEtapa src={LogoEtapa} />
                    </Row>
                    <Row className="mb-3 justify-content-center">
                        <Label>ANAMNESE</Label>
                    </Row>
                    <Description>Responda com sinceridade e calma. Quanto mais a gente souber de você, mais certeira será a forma que vamos te acompanhar - do seu jeito, no seu tempo.</Description>
                </Row>
                <fieldset disabled={loading}>
                    {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
                    <TitleAnamnese>1. SOBRE SUA ROTINA HOJE</TitleAnamnese>

                    {/*Sedentária*/}
                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você se considera ativa fisicamente ou sedentária?</VbFormLabel>

                        <VbCheckBox id="fisicamente-sedentaria" label="Sedentária" onClick={handleCheckboxChange("sedentaria", setFisicamente)} />
                        <VbCheckBox id="fisicamente-musculacao" label="Faço Musculação" onClick={handleCheckboxChange("musculacao", setFisicamente)} />
                        <VbCheckBox id="fisicamente-pilates" label="Faço Pilates" onClick={handleCheckboxChange("pilates", setFisicamente)} />
                        <VbCheckBox id="fisicamente-fisioterapia" label="Faço Fisioterapia" onClick={handleCheckboxChange("fisioterapia", setFisicamente)} />
                        <VbCheckBox id="fisicamente-outros" label="Prático outro(s) esporte(s)" onClick={handleCheckboxChange("outros", setFisicamente)} />
                    </Row>

                    {/*Se Sedentária */}
                    {fisicamente.sedentaria ?
                        <Row className="mb-4 justify-content-center">
                            <VbFormLabel>Há quanto tempo não treina com regularidade?</VbFormLabel>

                            <VbCheckBox id="sedentaria-seismeses" type="radio" group="sedentaria" label="Sedentária" onClick={handleCheckboxChange("seismeses", setSedentaria, true)} />
                            <VbCheckBox id="sedentaria-umano" type="radio" group="sedentaria" label="Faço Musculação" onClick={handleCheckboxChange("umano", setSedentaria, true)} />
                            <VbCheckBox id="sedentaria-nunca" type="radio" group="sedentaria" label="Faço Pilates" onClick={handleCheckboxChange("nunca", setSedentaria, true)} />
                        </Row> : null
                    }

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Qual dessas frases mais se parece com você hoje?</VbFormLabel>

                        <VbCheckBox id="frase-tentando" type="radio" group="frase" label="Tô tentando sair do zero" onClick={handleCheckboxChange("tentando", setFrase, true)} />
                        <VbCheckBox id="frase-comecei" type="radio" group="frase" label="Já comecei outras vezes, mas nunca fui constante" onClick={handleCheckboxChange("comecei", setFrase, true)} />
                        <VbCheckBox id="frase-jatreino" type="radio" group="frase" label="Já treino, mas quero algo que me desafie e motive mais" onClick={handleCheckboxChange("jatreino", setFrase, true)} />
                    </Row>

                    {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
                    <TitleAnamnese>2. O QUE TE IMPEDE HOJE?</TitleAnamnese>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você tem alguma lesão ou dor em articulações com frequência?</VbFormLabel>

                        <VbCheckBox id="lesal-sim" type="radio" group="lesal" label="Sim" onClick={handleCheckboxChange("sim", setLesao, true)} />
                        <VbCheckBox id="lesal-nao" type="radio" group="lesal" label="Não" onClick={handleCheckboxChange("nao", setLesao, true)} />
                    </Row>

                    {lesao.sim ?
                        <Row className="mb-4 justify-content-center">
                            <Input
                                ref={lesao_desc_ref}
                                id="lesao_desc"
                                type="text"
                                label="Onde sente? E qual a intensidade da dor de 0 a 10? Onde 10 é muita dor. (Exemplo: Joelho direito, dor 6)"
                                textarea
                                required={lesao.sim}
                                rows={3}
                                maxLength={1500}
                            />
                        </Row> : null}

                    <Row className="mb-4 justify-content-center">
                        <Input
                            ref={dificil_exercitar_ref}
                            id="dificil_exercitar"
                            type="text"
                            label="O que você acredita ser mais difícil quando o assunto é se exercitar?"
                            textarea
                            required
                            rows={3}
                            maxLength={1500}
                        />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Qual sua maior dificuldade hoje para se cuidar?</VbFormLabel>

                        <VbCheckBox id="dificuldade-se-cuidar-tempo" label="Falta de tempo" onClick={handleCheckboxChange("tempo", setDificuldadeSeCuidar)} />
                        <VbCheckBox id="dificuldade-se-cuidar-motivacao" label="Falta de motivação" onClick={handleCheckboxChange("motivacao", setDificuldadeSeCuidar)} />
                        <VbCheckBox id="dificuldade-se-cuidar-solitario" label="Me sinto sozinha nesse processo" onClick={handleCheckboxChange("solitario", setDificuldadeSeCuidar)} />
                        <VbCheckBox id="dificuldade-se-cuidar-frustrei" label="Já tentei e me frustrei" onClick={handleCheckboxChange("frustrei", setDificuldadeSeCuidar)} />
                        <VbCheckBox id="dificuldade-se-cuidar-naoseicomecar" label="Não sei nem por onde começar" onClick={handleCheckboxChange("naoseicomecar", setDificuldadeSeCuidar)} />
                        <VbCheckBox id="dificuldade-se-cuidar-outra" label="Outra" onClick={handleCheckboxChange("outra", setDificuldadeSeCuidar)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <Input
                            ref={dividir_ref}
                            id="dividir-ref"
                            type="text"
                            label="Ao procurar a VB Fit, o que você sonha? (Quanto mais você dividr com a gente, mais a gente pode cuidar de você do jeito certo)."
                            textarea
                            required
                            rows={3}
                            maxLength={1500}
                        />
                    </Row>

                    {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
                    <TitleAnamnese>3. COMO VOCÊ FUNCIONA?</TitleAnamnese>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você se considera uma pessoa perfeccionista?</VbFormLabel>

                        <VbCheckBox id="perfeccionista-sim" type="radio" group="perfeccionista" label="Sim" onClick={handleCheckboxChange("sim", setPerfeccionista, true)} />
                        <VbCheckBox id="perfeccionista-nao" type="radio" group="perfeccionista" label="Não" onClick={handleCheckboxChange("nao", setPerfeccionista, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você gosta de fazer as coisas do seu jeito, no seu tempo e da sua forma?</VbFormLabel>

                        <VbCheckBox id="seujeito-sim" type="radio" group="seujeito" label="Sim" onClick={handleCheckboxChange("sim", setSeujeito, true)} />
                        <VbCheckBox id="seujeito-nao" type="radio" group="seujeito" label="Não" onClick={handleCheckboxChange("nao", setSeujeito, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você é mais...</VbFormLabel>

                        <VbCheckBox id="perfil-introvertida" type="radio" group="perfil" label="Introvertida / tímida / mais reservada" onClick={handleCheckboxChange("introvertida", setPerfil, true)} />
                        <VbCheckBox id="perfil-extrovertida" type="radio" group="perfil" label="Extrovertida / comunicativa / mais sociável" onClick={handleCheckboxChange("extrovertida", setPerfil, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você se percebe como...</VbFormLabel>

                        <VbCheckBox id="execucao-independente" type="radio" group="execucao" label="Mais independente para executar tarefas" onClick={handleCheckboxChange("independente", setExecucao, true)} />
                        <VbCheckBox id="execucao-dependente" type="radio" group="execucao" label="Mais dependente, um pouco insegura" onClick={handleCheckboxChange("dependente", setExecucao, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Como você aprende melhor?</VbFormLabel>

                        <VbCheckBox id="aprendizado-tato" type="radio" group="aprendizado" label="Sentindo no corpo (tato)" onClick={handleCheckboxChange("tato", setAprendizado, true)} />
                        <VbCheckBox id="aprendizado-visual" type="radio" group="aprendizado" label="Vendo como se faz (visual)" onClick={handleCheckboxChange("visual", setAprendizado, true)} />
                        <VbCheckBox id="aprendizado-auditiva" type="radio" group="aprendizado" label="Ouvindo instruções (auditiva)" onClick={handleCheckboxChange("auditiva", setAprendizado, true)} />
                    </Row>


                    {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
                    <TitleAnamnese>4. SAÚDE E CUIDADOS GERAIS</TitleAnamnese>

                    <Row className="mb-4 justify-content-center">
                        <Input
                            ref={gestanteSemanas_ref}
                            id="gestante-semanas"
                            type="text"
                            label="Você está gestante? Se sim, com quantas semanas?"
                            maxLength={100}
                            required
                        />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você costuma sentir algum desses sintomas?</VbFormLabel>

                        <VbCheckBox id="sintomas-tontura" label="Tontura" onClick={handleCheckboxChange("tontura", setSintomas)} />
                        <VbCheckBox id="sintomas-desmaios" label="Desmaios" onClick={handleCheckboxChange("desmaios", setSintomas)} />
                        <VbCheckBox id="sintomas-escurecimento" label="Escurecimento da vista" onClick={handleCheckboxChange("escurecimento", setSintomas)} />
                        <VbCheckBox id="sintomas-dorPeito" label="Dor no peito" onClick={handleCheckboxChange("dorPeito", setSintomas)} />
                        <VbCheckBox id="sintomas-taquicardia" label="Taquicardia" onClick={handleCheckboxChange("taquicardia", setSintomas)} />
                        <VbCheckBox id="sintomas-faltaAr" label="Falta de ar" onClick={handleCheckboxChange("faltaAr", setSintomas)} />
                        <VbCheckBox id="sintomas-nenhum" label="Nenhum dos anteriores" onClick={handleCheckboxChange("nenhum", setSintomas)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <Input
                            ref={cirurgia_ref}
                            id="cirurgia"
                            type="text"
                            label="Já fez alguma cirurgia? Se sim, qual?"
                            maxLength={1500}
                            textarea
                            required
                        />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você tem hipertensão arterial?</VbFormLabel>

                        <VbCheckBox id="hipertensao-sim" type="radio" group="hipertensao" label="Sim" onClick={handleCheckboxChange("sim", setHipertensao, true)} />
                        <VbCheckBox id="hipertensao-nao" type="radio" group="hipertensao" label="Não" onClick={handleCheckboxChange("nao", setHipertensao, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você tem alguma doença cardiovascular?</VbFormLabel>

                        <VbCheckBox id="doencaCardio-sim" type="radio" group="doencaCardiovascular" label="Sim" onClick={handleCheckboxChange("sim", setCardio, true)} />
                        <VbCheckBox id="doencaCardio-nao" type="radio" group="doencaCardiovascular" label="Não" onClick={handleCheckboxChange("nao", setCardio, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você vai ao médico com regularidade?</VbFormLabel>

                        <VbCheckBox id="medicoRegular-sim" type="radio" group="medicoRegular" label="Sim" onClick={handleCheckboxChange("sim", setMedico, true)} />
                        <VbCheckBox id="medicoRegular-nao" type="radio" group="medicoRegular" label="Não" onClick={handleCheckboxChange("nao", setMedico, true)} />
                    </Row>

                    {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
                    <TitleAnamnese>5. FORMATO IDEAL PRA VOCÊ</TitleAnamnese>

                    <Row className="mb-4 justify-content-center">
                        <VbFormLabel>Você gostaria de treinar com a gente de forma...</VbFormLabel>

                        <VbCheckBox id="formato-presencial" type="radio" group="formatoTreino" label="Presencial" onClick={handleCheckboxChange("presencial", setFormatoTreino, true)} />
                        <VbCheckBox id="formato-online" type="radio" group="formatoTreino" label="Online" onClick={handleCheckboxChange("online", setFormatoTreino, true)} />
                        <VbCheckBox id="formato-ambos" type="radio" group="formatoTreino" label="Ambos" onClick={handleCheckboxChange("ambos", setFormatoTreino, true)} />
                        <VbCheckBox id="formato-naosei" type="radio" group="formatoTreino" label="Ainda não sei" onClick={handleCheckboxChange("naoSei", setFormatoTreino, true)} />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <Input
                            ref={instagram_ref}
                            id="instagram"
                            type="text"
                            label="Qual seu @ no Instagram?"
                            maxLength={100}
                            required
                        />
                    </Row>

                    <Row className="mb-4 justify-content-center">
                        <Input
                            ref={compartilha_ref}
                            id="compartilha"
                            type="text"
                            label="Por fim... tem algo mais que você gostaria de compartilhar com a gente? (Aqui pode ser uma dúvida, um pedido, uma história ou algo que você sente que a gente precisa saber.)"
                            textarea
                            maxLength={1500}
                            required
                        />
                    </Row>


                    {/*--------------------------------------------------------------------------------------------------------------------------------------------------*/}
                    <TitleAnamnese>TERMO DE RESPONSABILIDADE</TitleAnamnese>

                    <Row className="mb-4 justify-content-center">
                        <Input id="termos" type="text" textarea rows={10} maxLength={1500} disabled defaultValue={`É de grande importância a consulta ao seu médico, bem como a realização de exames complementares, (como eletrocardiograma e outros), antes de praticar qualquer atividade física, tendo em vista os riscos que envolvem esta prática. Declaração: Declaro ao finalizar esse questionário estar ciente dos termos acima, bem como estar em plenas condições de saúde. Além disso, declaro ter passado ao professor, todas as informações relativas à minha saúde, tais como limitações, lesões e dores que sinto. Assim sendo, assumo total responsabilidade pelo meu estado de saúde, isentando a VB Fit sobre qualquer acontecimento dentro de suas dependências. Em caso de acidente, ou qualquer outra situação que gere risco para a minha saúde, dentro das instalações do estúdio, quando houver necessidade de socorros médicos, autorizo a VB Fit a realizar os primeiros socorros e o devido encaminhamento, (incluindo remoção profissional, caso necessário) e assumo desde já, única e exclusivamente, a responsabilidade por todas as despesas médicas e hospitalares geradas.`} />
                        <VbCheckBox id="termosim" group="termo" type="radio" label="Sim" onClick={() => setTermo(1)} />
                        <VbCheckBox id="termonao" group="termo" type="radio" label="Não" onClick={() => setTermo(0)} />
                    </Row>
                    <Row className="mt-3 mb-4 justify-content-center" style={{ padding: '0 8px' }}>
                        <VbButton type="submit" size={undefined} style={{ justifyContent: 'center' }}>ENVIAR</VbButton>
                    </Row>
                </fieldset>
            </Form>
        </FormContainer >
    )
})